import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { TeamsLivePersonaCardProps } from './TeamsLivePersonaCard';

const loader = () =>
  import(/* webpackChunkName: "4-feat-teams-live-persona-card" */ './TeamsLivePersonaCardErrorBoundary');

const LoadableTeamsLivePersonaCard: ComponentType<TeamsLivePersonaCardProps> = lazyLoadOnRender({ loader });
export default LoadableTeamsLivePersonaCard;
